export function initXMLHttpRequestActiveCounter() {
  // @ts-expect-error TS(2339): Property '_allRequests' does not exist on type '{ ... Remove this comment to see the full error message
  // oxlint-disable-next-line no-underscore-dangle
  XMLHttpRequest._allRequests = [];
  // @ts-expect-error TS(2339): Property '_completedRequests' does not exist on ty... Remove this comment to see the full error message
  // oxlint-disable-next-line no-underscore-dangle
  XMLHttpRequest._completedRequests = [];

  // oxlint-disable-next-line @typescript-eslint/unbound-method
  const oldOpen = XMLHttpRequest.prototype.open;

  // @ts-expect-error TS(2322): Type '(args_0: string, args_1: string | URL, args_... Remove this comment to see the full error message
  XMLHttpRequest.prototype.open = function open(...args) {
    const [, url] = args;
    // TODO: Fix this the next time the file is edited.
    // @ts-expect-error TS(2339): Property '_url' does not exist on type 'XMLHttpReq... Remove this comment to see the full error message
    // oxlint-disable-next-line no-underscore-dangle
    this._url = url;
    // @ts-expect-error TS(2345): Argument of type '[string, string | URL, unknown, ... Remove this comment to see the full error message
    oldOpen.apply(this, args);
  };

  // oxlint-disable-next-line @typescript-eslint/unbound-method
  const oldSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.send = function send(...args) {
    // @ts-expect-error TS(2339): Property '_url' does not exist on type 'XMLHttpReq... Remove this comment to see the full error message
    // oxlint-disable-next-line no-underscore-dangle,@typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
    if (!this._url.includes('sockjs-node')) {
      // @ts-expect-error TS(2339): Property '_allRequests' does not exist on type '{ ... Remove this comment to see the full error message
      // oxlint-disable-next-line no-underscore-dangle,@typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
      XMLHttpRequest._allRequests.push(this._url);

      this.addEventListener('loadend', () => {
        setTimeout(() => {
          // @ts-expect-error TS(2339): Property '_completedRequests' does not exist on ty... Remove this comment to see the full error message
          // oxlint-disable-next-line no-underscore-dangle,@typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
          XMLHttpRequest._completedRequests.push(this._url);
        }, 1);
      });
    }

    oldSend.apply(this, args);
  };

  const oldFetch = window.fetch.bind(window);

  window.fetch = function fetch(
    input: RequestInfo | URL,
    init?: RequestInit,
  ): Promise<Response> {
    let url: string;
    if (typeof input === 'string') {
      url = input;
    } else if (input instanceof URL) {
      url = input.href;
    } else {
      ({ url } = input);
    }

    if (url.includes('sockjs-node')) {
      return oldFetch(input, init);
    }

    // @ts-expect-error TS(2339): Property '_allRequests' does not exist on type '{ ... Remove this comment to see the full error message
    // oxlint-disable-next-line no-underscore-dangle,@typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
    XMLHttpRequest._allRequests.push(url);

    return oldFetch(input, init).then(
      (response: Response) => {
        setTimeout(() => {
          // @ts-expect-error TS(2339): Property '_completedRequests' does not exist on ty... Remove this comment to see the full error message
          // oxlint-disable-next-line no-underscore-dangle,@typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
          XMLHttpRequest._completedRequests.push(url);
        }, 1);
        return response;
      },
      (error: unknown) => {
        setTimeout(() => {
          // @ts-expect-error TS(2339): Property '_completedRequests' does not exist on ty... Remove this comment to see the full error message
          // oxlint-disable-next-line no-underscore-dangle,@typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
          XMLHttpRequest._completedRequests.push(url);
        }, 1);
        throw error;
      },
    );
  };
}
